<script>
	import { api } from "./../libs/api.js";
	import { _ } from 'svelte-i18n';

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";

	export let id;

	let excursion = api.get_excursion(id);
</script>

<BaseLayer>
	<div class="w-48 mt-8 mx-auto">
		<img src="/assets/caa/backpack.svg">
	</div>

	<h2 class="page-title py-10 text-center"> {$_('backpack.dont_forget')} </h2>

	<div class="grid grid-cols-2 gap-x-16 gap-y-8 mx-8">
		{#await excursion then value}
		{#each value.data.equipment as item}
			<label class="swap">
				<input type="checkbox" />
				<div class="swap-on"><img src="/assets/caa/{item}.png"></div>
				<div class="swap-off opacity-50"><img src="/assets/caa/{item}.png"></div>
			</label>
		{/each}
		{/await}
	</div>

	<div class="text-center my-8">
		<Link class="btn btn-accent w-72 font-bold text-md mt-3 rounded-3xl" to="excursions/{id}"> {$_('backpack.ready')} </Link>
	</div>
</BaseLayer>

